import script from "./clotheDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./clotheDetails.vue?vue&type=script&setup=true&lang=js"

import "./clotheDetails.vue?vue&type=style&index=0&id=0c2daf4c&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c2daf4c"]])

export default __exports__